/* eslint-disable @typescript-eslint/no-explicit-any */
import { Form } from 'antd';
import VerificationModal from 'components/bank/AGBBank/VerificationModal/VerificationModal';
import { formattedAccountList } from 'components/shared/AccountDropdown';
import { formattedContactAccountList } from 'components/shared/ContactDropdown';
import useDynamicForm from 'hooks/useDynamicForm';
import { IOssixProvider } from 'interfaces/otherInterface/dynamicInput';
import { ICountryInfo } from 'interfaces/otherInterface/supportedCountry';
import { IAccountInfo } from 'interfaces/queries/account';
import { ISelectedOption } from 'interfaces/queries/bills';
import InternationalTransfer from 'pages/bank/Transfer/InternationalTransfer';
import { ossixSupportCountries } from 'queries/ossix/otherQuery';
import { getUserContact } from 'queries/ossix/user/userData';
import { userAccountNumbers } from 'queries/ossix/wallet/requestWallet';
import { useEffect, useState } from 'react';
import { TargetType } from 'types/generalType';

interface InternationalTransferContainerProps {
  isDrawerOpen: any;
  handleCloseOpenDrawer: any;
  selectedOption?: any;
}

const InternationalTransferContainer: React.FC<
  InternationalTransferContainerProps
> = ({ isDrawerOpen, handleCloseOpenDrawer, selectedOption }) => {
  const [form] = Form.useForm();
  const state = selectedOption;
  const [accountNumber, setAccountNumber] = useState();
  const [contactAccount, setContactAccount] = useState<any>();
  const [selectCountry, setSelectCountry] =
    useState<ICountryInfo | null>(null);
  const { loadUserAccountNumbers, accountNumbers } =
    userAccountNumbers();

  const { isLoading, countries } = ossixSupportCountries();
  const [step, setStep] = useState(1);
  const [displaySelectContact, setDisplaySelectContact] =
    useState(false);
  const [selectedBeneficiary, setSelectedBeneficiary] =
    useState<any>();
  const [selectedProvider, setSelectedProvider] = useState<
    IOssixProvider | undefined
  >();
  const [option, setOption] = useState<ISelectedOption | undefined>();

  const onHandleDisplaySelectContact = () =>
    setDisplaySelectContact(true);

  const onHandleCloseSelectContact = () => {
    setDisplaySelectContact(false);
    setSelectedBeneficiary(undefined);
    setContactAccount({
      value: '',
      label: '',
    });
  };

  const accountNumbersInfo: IAccountInfo[] = accountNumbers;
  const selectAccountNumber = formattedAccountList(
    accountNumbersInfo,
  );

  const {
    fields,
    meta,
    handleInputChange,
    loadVerifyAccount,
    onHandleVerifyAccount,
    filterCountry,
    isVerifyAccountSuccess,
    contextHolder,
    onHandleValueChange,
    onHandleBankGatewayTransferConfirmation,
    loadTransferConfirmation,
    transferConfirmationData,
    onPINValuesChange,
    onHandleBankConfirmTransfer,
    loadSendFundsToGateway,
    userData,
    setFormData,
    formData,
    fixedInputValue,
    setFixedInputValue,
    onChangeFixedInputValue,
    clearTransferConfirmation,
    onHandleSaveContact,
    openPrintTransaction,
    sendFundsToGatewayData,
    onHandleClosePrintPage,
    showVerificationModal,
    verificationData,
    handleVerificationComplete,
    handleVerificationCancel,
  } = useDynamicForm({
    selectCountry: selectCountry,
    jsonFields: selectedProvider?.Fields as string,
    provider: selectedProvider,
    accountNumber: accountNumber,
    nextStep: setStep,
    form: form,
    accountNumberName: selectAccountNumber?.[0]?.text,
    selectedBeneficiary: selectedBeneficiary,
    handleCloseOpenDrawer: handleCloseOpenDrawer,
  });

  const { isLoadingContacts, userContactData } = getUserContact({
    CountryCode: userData?.[0]?.OperationCountry,
  });

  const recipientAccountNumber = formattedContactAccountList(
    userContactData &&
      userContactData?.filter(
        (item: { Category: TargetType }) =>
          item?.Category === TargetType.Bank,
      ),
  );

  const onPrevious = () => {
    setStep((prevStep) => prevStep - 1);
    clearTransferConfirmation();
    setFixedInputValue('');
  };

  useEffect(() => {
    if (state) {
      const beneficiary = userContactData?.find(
        (item: { AccountNumber: any }) =>
          item.AccountNumber === state?.AccountNumber,
      );
      setSelectedBeneficiary({
        ...beneficiary,
        ...beneficiary?.Operator,
      });

      setFormData((prev: any) => ({
        ...prev,
        ...{
          serviceNumber: state?.AccountNumber,
          phoneNumber: state?.PhoneNumber || state?.AccountNumber,
        },
      }));
    }
  }, [state]);

  useEffect(() => {
    if (contactAccount?.value) {
      const beneficiary = userContactData?.find(
        (item: { AccountNumber: any }) =>
          item.AccountNumber === contactAccount?.value,
      );
      setSelectedBeneficiary({
        ...beneficiary,
        ...beneficiary?.Operator,
      });

      setFormData((prev: any) => ({
        ...prev,
        ...{
          serviceNumber: contactAccount?.value,
          phoneNumber: contactAccount?.value,
        },
      }));
    }
  }, [contactAccount?.value]);

  return (
    <>
      <InternationalTransfer
        step={step}
        selectAccountNumber={selectAccountNumber}
        form={form}
        option={option}
        onPrevious={onPrevious}
        accountNumber={accountNumber}
        setAccountNumber={setAccountNumber}
        loadingAccount={loadUserAccountNumbers}
        recipientAccountNumber={recipientAccountNumber}
        onHandleDisplaySelectContact={onHandleDisplaySelectContact}
        displaySelectContact={displaySelectContact}
        isLoadingContacts={isLoadingContacts}
        contactAccount={contactAccount}
        setContactAccount={setContactAccount}
        onHandleCloseSelectContact={onHandleCloseSelectContact}
        setSelectedProvider={setSelectedProvider}
        selectedProvider={selectedProvider}
        setStep={setStep}
        countries={countries}
        loadingCountry={isLoading}
        setSelectCountry={setSelectCountry}
        selectCountry={selectCountry}
        isDrawerOpen={isDrawerOpen}
        handleCloseOpenDrawer={handleCloseOpenDrawer}
        dynamicFormItem={{
          state,
          fields: fields,
          meta: meta,
          handleInputChange: handleInputChange,
          loadVerifyAccount: loadVerifyAccount,
          onHandleVerifyAccount: onHandleVerifyAccount,
          filterCountry: filterCountry,
          isVerifyAccountSuccess: isVerifyAccountSuccess,
          contextHolder: contextHolder,
          onHandleValueChange: onHandleValueChange,
          onHandleTransferConfirmation:
            onHandleBankGatewayTransferConfirmation,
          loadTransferConfirmation: loadTransferConfirmation,
          transferConfirmationData: transferConfirmationData,
          onPINValuesChange: onPINValuesChange,
          loadSendFundsToGateway: loadSendFundsToGateway,
          onHandleConfirmTransfer: onHandleBankConfirmTransfer,
          userData,
          formData,
          fixedInputValue,
          setFixedInputValue,
          onChangeFixedInputValue,
          selectedBeneficiary,
          setSelectedBeneficiary,
          onHandleSaveContact,
          openPrintTransaction,
          sendFundsToGatewayData,
          onHandleClosePrintPage,
        }}
      />
      <VerificationModal
        isVisible={showVerificationModal}
        otpRequired={verificationData.otpRequired}
        selfieRequired={verificationData.selfieRequired}
        onComplete={handleVerificationComplete}
        onCancel={handleVerificationCancel}
        loading={loadTransferConfirmation}
      />
    </>
  );
};

export default InternationalTransferContainer;
